import IntlLink from "@components/Intl/IntlLink"
import React from "react"
import * as S from "./elements"
import { Box } from "@components/Layout"

interface Item {
  label: string
  as?: string
  href?: any
}

interface Props {
  items: Item[]
}

export const Breadcrumbs: React.FC<Props> = ({ items }) => {
  return (
    <Box display={["none", "flex"]}>
      {items[0].href && (
        <S.SingleWrapper>
          <IntlLink href={items[0].href} as={items[0].as}>
            <S.Anchor href={items[0].as}>{items[0].label}</S.Anchor>
          </IntlLink>
        </S.SingleWrapper>
      )}

      {items.slice(1).map((item, key) => (
        <S.SingleWrapper last={key === items.length - 2} key={key}>
          <S.Chevron />
          {item.href ? (
            <IntlLink href={item.href} as={item.as}>
              <S.Anchor href={item.as}>{item.label}</S.Anchor>
            </IntlLink>
          ) : (
            <S.Anchor>{item.label}</S.Anchor>
          )}
        </S.SingleWrapper>
      ))}
    </Box>
  )
}
